import * as React from 'react';

import { FieldWrapper, FieldWrapperPassThroughProps } from './FieldWrapper';

export type InputProps = React.InputHTMLAttributes<HTMLInputElement> &
  FieldWrapperPassThroughProps & {
    className?: string;
    onIconClick?: () => void;
  };

const TextInput = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type = 'text', label, errorMessage, onIconClick, ...props }, ref) => {
    const inputId = label;

    return (
      <FieldWrapper
        label={label}
        errorMessage={errorMessage}
        float={true}
        className={className}
        htmlFor={inputId}
        onIconClick={onIconClick}
      >
        <input
          ref={ref}
          id={inputId}
          type={type}
          aria-required="true"
          placeholder={label}
          aria-invalid={errorMessage ? 'true' : 'false'}
          className={`iLendingCDX-text-field__float ${errorMessage && 'iLendingCDX-text-field__float--error'}`}
          {...props}
        />
      </FieldWrapper>
    );
  }
);

export { TextInput };
